import { URN } from '@youhelp-ru/urn';

export type Primitive = bigint | number | boolean | null | string | undefined;
export type JSONValue = Primitive | JSONObject | JSONArray;
interface JSONObject {
  [key: string]: JSONValue;
}
interface JSONArray extends Array<JSONValue> {}

const base64UrlEncodeString = (str: string) => {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const base64UrlDecodeToString = (base64url: string) => {
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  return atob(base64 + '='.repeat((4 - (base64.length % 4)) % 4));
};

export type IntentData<P extends JSONArray = JSONArray> = {
  action: string;
  params: P;
};

/**
 * Хранит пользовательское намерение.
 * Action - функция которую нужно вызывать
 * Params - массив параметров функции
 */
export class Intent<Params extends JSONArray = JSONArray> extends URN {
  readonly #action: string;
  readonly #params: Params;

  constructor(data: IntentData<Params>) {
    const { action, params } = data;
    const nss = [data.action, base64UrlEncodeString(JSON.stringify(params))].join('.');
    super({ nid: 'x-feature', nss });
    this.#action = action;
    this.#params = params;
  }

  get params(): Params {
    return this.#params;
  }

  get action(): string {
    return this.#action;
  }

  toJSON(): IntentData<Params> {
    return {
      action: this.#action,
      params: this.#params,
    };
  }

  static parse<P extends JSONArray = JSONArray>(str) {
    const { nid, nss } = URN.parse(str);
    if (nid !== 'x-feature') {
      throw new TypeError('Wrong URN type');
    }
    return new Intent(Intent.parseNSString<P>(nss));
  }

  static parseNSString<P extends JSONArray>(nss: string): IntentData<P> {
    const [action, params] = nss.split('.');
    return { action, params: JSON.parse(base64UrlDecodeToString(params)) };
  }
}
